import React from "react";
import { formatNumber } from "../../utils/convertToNumber";

const RefundDetails = React.memo(({ booking }) => (
  <td colSpan="6" className="px-4 py-4 bg-gray-50">
    <div className="grid grid-cols-1 gap-6 md:ml-10 md:grid-cols-3">
      <div>
        <h4 className="mb-2 text-sm font-semibold tracking-wider text-black uppercase">
          Passengers ({booking.passengers.length})
        </h4>
        <div className="space-y-2">
          {booking.passengers.map((p) => (
            <div key={p._id} className="p-2 bg-white rounded-md border">
              <div className="flex justify-between items-center">
                <p className="text-sm font-medium text-gray-800">
                  {p.firstName} {p.lastName}
                </p>
                <span className="text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800 font-medium">
                  {p.type}
                </span>
              </div>
              <p className="mt-1 text-xs text-gray-600">
                Ticket: <span className="font-mono">{p.ticketNumber}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
      <div>
        <h4 className="mb-2 text-sm font-semibold tracking-wider text-black uppercase">
          Flight Details
        </h4>
        <div className="space-y-1 text-sm text-gray-700">
          <p>
            <span className="font-medium">Type:</span>{" "}
            {booking.flight.flightType}
          </p>
          <p>
            <span className="font-medium">Carrier:</span>{" "}
            {booking.flight.carrier}
          </p>
          <p>
            <span className="font-medium">Payment:</span>{" "}
            {booking.payment.toUpperCase()}
          </p>
          <p>
            <span className="font-medium">Booked on:</span>{" "}
            {new Date(booking.createdAt).toLocaleDateString()}
          </p>
        </div>
      </div>
      <div>
        <h4 className="mb-2 text-sm font-semibold tracking-wider text-black uppercase">
          Billing Details
        </h4>
        <div className="space-y-1 text-sm text-gray-700">
          <p>
            <span className="font-medium">Base Fare:</span>{" "}
            {formatNumber(booking.flight?.price)}
          </p>
          <p>
            <span className="font-medium">Service Charge:</span>{" "}
            {formatNumber(booking.serviceCharge)}
          </p>
          <p>
            <span className="font-medium">Total Paid Amount:</span>{" "}
            {formatNumber(booking.totalPaidAmount)}
          </p>
          <p>
            <span className="font-medium">To Be Refunded Amount:</span>{" "}
            {formatNumber(booking.toBeRefunded)}
          </p>
        </div>
      </div>
    </div>
  </td>
));

export default RefundDetails;
